"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingError = void 0;
var Shipping_1 = require("./Shipping");
Object.defineProperty(exports, "ShippingError", { enumerable: true, get: function () { return Shipping_1.ShippingError; } });
//# sourceMappingURL=ExternalContract.js.map